// extracted by mini-css-extract-plugin
export var actionButton = "_yo-2";
export var card = "_yo-0";
export var disambiguationList = "_yo-3";
export var errorCard = "_yo-4";
export var row = "_yo-1";